import header from "./components/header";
import body from "./components/body";
import footer from "./components/footer";
import paragraph from "./components/generic/paragraph";
import picture from "./components/generic/picture";
import page from "./components/page";
import columns from "./components/columns";
import column from "./components/column";
import button from "./components/generic/button";

export default editor => {
 const components = [
     header,
     body,
     footer,
     page,
     columns,
     column,
     paragraph,
     picture,
     button
 ]
 components.forEach(c => c(editor))

}
